import { useQuery } from '@apollo/client'
import moment from 'moment'
import { BucketInvitation, BucketInvitationStatus, BucketUserRole, BucketUsersAndInvitationsDocument } from '../../../graphql/generated'
import useBucket from './useBucket'

export interface FormattedBucketInvitation {
  id: string
  name?: string | null
  userRole: BucketUserRole
  invite?: BucketInvitation
  bucketId: string
  isGeneric: boolean
}

export default function useGetBucketUsersAndInvitations(bucketIdParam?: string) {
  const { bucket } = useBucket()
  const bucketId = bucketIdParam ?? bucket?.id
  const query = useQuery(BucketUsersAndInvitationsDocument, {
    skip: !bucketId,
    variables: { bucketId: bucketId! },
    fetchPolicy: 'cache-and-network'
  })

  const getName = (item: BucketInvitation) => {
    if (item.email) {
      return item.invitationStatus === BucketInvitationStatus.Pending ? `${item.email} (Pending)` : item.email
    }

    return `Invite Link - ${moment(item.createdAt).format('MM/DD/YY')}`
  }

  const bucketUsers = query?.data?.bucketUsers?.items ?? []
  const allInvitations = query?.data?.bucketInvitations?.items
  const genericInvitations = allInvitations?.filter((item) => !item.email)
  const userSpecificInvitations = allInvitations?.filter((item) => Boolean(item.email)) || []
  const bucketUsersAndUserInvitations = [...bucketUsers, ...userSpecificInvitations]
  const formattedInvitations: FormattedBucketInvitation[] =
    allInvitations?.map((item) => ({
      id: item.id,
      name: getName(item),
      userRole: item.userRole,
      invite: item,
      bucketId: bucket?.id!,
      isGeneric: !item.email
    })) ?? []
  const items = [...bucketUsers, ...formattedInvitations]

  return {
    items,
    onRefresh: query.refetch,
    isRefreshing: query.loading,
    formattedInvitations,
    bucketUsers,
    allInvitations,
    genericInvitations,
    userSpecificInvitations,
    bucketUsersAndUserInvitations
  }
}
